var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVariableImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "none",
    width: "none",
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11644_23340)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_11644_23340",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3C3.5 2.44772 3.94772 2 4.5 2H54.5C55.0523 2 55.5 2.44772 55.5 3V53C55.5 53.5523 55.0523 54 54.5 54H4.5C3.94772 54 3.5 53.5523 3.5 53V3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3C3.5 2.44772 3.94772 2 4.5 2H54.5C55.0523 2 55.5 2.44772 55.5 3V53C55.5 53.5523 55.0523 54 54.5 54H4.5C3.94772 54 3.5 53.5523 3.5 53V3Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2H55.5H3.5ZM55.5 53C55.5 54.1046 54.6046 55 53.5 55H5.5C4.39543 55 3.5 54.1046 3.5 53C3.5 53 3.94772 53 4.5 53H54.5C55.0523 53 55.5 53 55.5 53ZM3.5 54V2V54ZM55.5 2V54V2Z",
    fill: "#424242",
    mask: "url(#path-1-inside-1_11644_23340)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.4811,
    cy: 17.4889,
    rx: 5.3375,
    ry: 5.66667,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7812 25.6314L3.56172 52.4379C3.11048 53.1018 3.58603 54 4.38878 54H39.5935C39.9872 54 40.2264 53.5662 40.0164 53.2333L22.6176 25.6458C22.4254 25.341 21.9837 25.3334 21.7812 25.6314Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7901 33.7332L31.9604 53.2407C31.7584 53.574 31.9983 54 32.388 54H54.2935C55.0576 54 55.5394 53.1778 55.1659 52.5112L44.6538 33.7481C44.4666 33.414 43.9887 33.4057 43.7901 33.7332Z",
    fill: "#9F9F9F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.3,
    width: 56.9,
    height: 55.4,
    rx: 0.7,
    stroke: "#C6C6C6",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11644_23340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.5,
    height: 52,
    fill: "white",
    transform: "translate(2.5 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableImg);
export default __webpack_public_path__ + "static/media/variableImg.0a1a05decdc3d3073f2313c4929257f4.svg";
export { ForwardRef as ReactComponent };